import React, {Component} from 'react'
import Radium from 'radium'
import logo from './svg-symbol-viewer-logo.svg'

@Radium
export default class Header extends Component {
  render () {
    return (
      <header style={styles.container}>
        <div>
          <img style={styles.logo} src={logo} alt='' />
          <h1 style={styles.heading}>SVG-byggaren</h1>
        </div>
      </header>
    )
  }
}

const styles = {
  container: {
    backgroundColor: '#f9f7f1',
    color: '#000',
    left: '0px',
    top: '0px',
    padding: '1em',
    position: 'fixed',
    width: '100%',
    zIndex: '5',
    fontSize: '150%',
    '@media (min-width: 30em)': {
      fontSize: '180%'
    }
  },
  logo: {
    width: '2em',
    maxWidth: '25%',
    verticalAlign: 'middle'
  },
  heading: {
    display: 'inline-block',
    margin: '.5em',
    fontSize: 'inherit'
  }
}



// WEBPACK FOOTER //
// src/components/header/index.js